module.exports = __WEBPACK_EXTERNAL_MODULE_115__;


//////////////////
// WEBPACK FOOTER
// external "xes-frontend-ui/lib/question-tree"
// module id = 115
// module chunks = 5 11